import { useEffect, useState } from "react";
import axios from "axios";
import { CheckBox, NumberBox, Slider, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import { Label } from "devextreme-react/slider";
import { toastMsg } from "../utils";

const ConfigurePeriod = ({ item }) => {
  const [currPeriod, setPeriod] = useState(null);
  const [id, setId] = useState(null);
  const [isWholePeriod, setWholePeriod] = useState(false);
  const [newPeriod, setNewPeriod] = useState(currPeriod);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BECCO_API_URL}/api/mthlyReport/config?item=${item}`).then((res) => {
      const id = res.data.id;
      const value = res.data.value;
      setId(id);
      if (value === "999") {
        setWholePeriod(true);
        setPeriod(999);
        setNewPeriod(999);
      } else {
        setPeriod(Number(value));
        setNewPeriod(Number(value));
      }
    });
  }, []);

  const formatPeriod = (value) => {
    return `${value}개월`;
  };

  const handlePeriodChange = (e) => {
    setNewPeriod(e.value);
  };

  const handleSavePeriod = () => {
    axios
      .put(`${process.env.REACT_APP_BECCO_API_URL}/api/mthlyReport/config/${id}`, { item, value: String(newPeriod) })
      .then(() => {
        setPeriod(newPeriod);
        toastMsg(`수정 가능 기간이 정상적으로 수정되었습니다`, true);
      })
      .catch((err) => {
        toastMsg(`에러가 발생했습니다. 관리자에게 문의해주세요.`, false);
        throw err;
      });
  };

  const handleWholePeriod = (e) => {
    if (isWholePeriod) {
      setWholePeriod(e.value);
      setNewPeriod(120);
    } else {
      setWholePeriod(e.value);
      setNewPeriod(999);
    }
  };

  const toolbarItemOptions = {
    icon: "save",
    disabled: currPeriod === newPeriod,
    onClick: handleSavePeriod,
  };

  return (
    <div>
      <Toolbar>
        <Item location="after" name="saveButton" options={toolbarItemOptions} widget="dxButton" />
      </Toolbar>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "16px" }}>
        <CheckBox iconSize={24} text="전체 기간 수정가능" onValueChanged={handleWholePeriod} value={isWholePeriod} />
        <Slider
          disabled={isWholePeriod}
          max={120}
          min={0}
          onValueChanged={handlePeriodChange}
          rtlEnabled={true}
          value={newPeriod}
          width={800}
        >
          <Label format={formatPeriod} position={"top"} visible={true} />
        </Slider>
        <NumberBox
          disabled={isWholePeriod}
          format={"#0개월 전까지 수정 가능"}
          max={120}
          min={0}
          onValueChanged={handlePeriodChange}
          showSpinButtons={true}
          value={newPeriod}
          width={200}
        />
      </div>
    </div>
  );
};

export default ConfigurePeriod;
